// Copyright ©️ 2026 eVolve MEP, LLC

import { forwardRef } from 'react';

import type { MantineLoaderComponent } from '@mantine/core';

import LogoAnimation from 'assets/icons/icon-src/indicators/evolve-v-logo-animation.svg?react';

// oxlint's react/function-component-definition does not exempt forwardRef render callbacks.
// oxlint-disable-next-line react/function-component-definition
export const LogoLoader: MantineLoaderComponent = forwardRef(({ style, ...others }, ref) => (
  <LogoAnimation
    ref={ref}
    style={{
      width: 'var(--loader-size)',
      height: 'var(--loader-size)',
      stroke: 'var(--loader-color)',
      ...style,
    }}
    {...others}
  />
));
